module.exports = __webpack_public_path__ + "e7a3a8297157c3ab0481bf930dc81644.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/opher-vishnia.jpg
// module id = 451
// module chunks = 0